"use client";
import { stateLayers } from "../../../styles/states.css.js";
import classNames from "classnames";
import { buttonRecipe } from "./styles.css.js";
const getButtonVariantProps = (color, { ...props }) => {
  var _a;
  return {
    ...props,
    className: classNames(props.className, buttonRecipe({
      color,
      buttonType: "box",
      isLoading: (_a = props.loading) == null ? void 0 : _a.isLoading
    }), color === "transparent" ? stateLayers({
      borderSize: "medium",
      borderRadius: "button",
      backgroundColor: "palette-black",
      setFocusState: true
    }) : stateLayers({
      borderSize: "none",
      borderRadius: "button",
      backgroundColor: `on-${color}`,
      setFocusState: true
    }))
  };
};
export {
  getButtonVariantProps
};
